import { formatHMS } from '../time/format'
import { useAttendanceToday } from './useAttendance'

const STATUS_LABEL: Record<string, string> = { an: 'anwesend', pause: 'in Pause', aus: 'nicht da' }
const STATUS_ORDER: Record<string, number> = { an: 0, pause: 1, aus: 2 }

/**
 * „Wer ist da?"-Panel der Serviceannahme (V1-Parität): Anwesenheit des ganzen Teams heute (GET
 * attendance?scope=today). Anwesende zuerst, dann Pause, dann abwesend. Status über Tokens (Punkt-Farbe),
 * kein per-User-Inlinecolor (CSP). Beiwerk: bei Ladefehler/leer verschwindet das Panel still.
 */
export function WhoIsInPanel() {
  const { data, isLoading, error } = useAttendanceToday()
  if (isLoading || error || !data || !data.entries || data.entries.length === 0) return null

  const entries = [...data.entries].sort(
    (a, b) => (STATUS_ORDER[a.status] ?? 3) - (STATUS_ORDER[b.status] ?? 3) || a.name.localeCompare(b.name),
  )
  const present = entries.filter((entry) => entry.status !== 'aus').length

  return (
    <section className="wf-whois" aria-label="Wer ist da">
      <div className="wf-whois__head">
        <h3 className="wf-whois__title">Wer ist da?</h3>
        <span className="wf-count">
          {present}/{entries.length}
        </span>
      </div>
      <div className="wf-whois__list">
        {entries.map((entry) => (
          <div key={entry.userId} className={`wf-whois__row wf-whois__row--${entry.status}`}>
            <span className="wf-whois__dot" aria-hidden="true" />
            <span className="wf-whois__name">{entry.name}</span>
            <span className="wf-whois__status">
              {STATUS_LABEL[entry.status] ?? entry.status}
              {entry.status !== 'aus' ? ` · ${formatHMS(entry.todaySeconds)}` : ''}
            </span>
          </div>
        ))}
      </div>
    </section>
  )
}
